exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-heading{position:relative;text-align:center}.app-heading .app-heading__heading-container{position:relative;margin-top:3.5rem;margin-bottom:6rem}.app-heading .app-heading__heading-container .app-heading__heading{position:relative;display:inline-block;color:#333;font-size:3rem;letter-spacing:3.5px;font-weight:500;text-transform:uppercase;width:\"auto\";height:\"auto\";margin-bottom:30px}.app-heading .app-heading__heading-container .app-heading__heading:before{content:\" \";display:block;position:absolute;height:4px;width:30%;background-color:#004f6b;bottom:-10px;left:50%;transform:translate(-50%)}.app-heading .app-heading__heading-container .app-heading__subheading{color:grey;font-weight:400;font-size:1.4rem;text-transform:uppercase}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6902f4e4","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/shared/AppHeading.vue
// module id = 158
// module chunks = 34